import DnDWrapper from '../DnDWrapper'
import EditorBarLeft from './EditorBarLeft'
import EditorBarRight from './EditorBarRight'
import EditorBarTop from './EditorBarTop'
import EditorCenter from './EditorCenter'

const Editor = () => {
  return (
    <DnDWrapper>
      <EditorBarLeft />
      <EditorBarTop />
      <EditorCenter />
      <EditorBarRight />
    </DnDWrapper>
  )
}

export default Editor
